module.exports = __webpack_public_path__ + "img/icon49.d2047265.png";